import { TeamCreationPayload } from "@modules/team/types";

import { ITeamFormData, ImageCreationType } from "./types";

export const prepareImageUploadPromises = (
  uploadedFileList: FileList | null,
  createImage: ImageCreationType
) => {
  if (!uploadedFileList) {
    return
  }

  const list = Array.from(uploadedFileList).map((file) => {
    // when will develop team update
    if (!(file instanceof FileList)) {
    //   return Promise.resolve(file.url)
    }

    const formData = new FormData();

    formData.append('files[]', file);

    const response = createImage(formData).unwrap()

    return response
  })

  return list
};

export const prepareClonedData = (
  data: ITeamFormData,
  imagePaths: string[],
): TeamCreationPayload => {
  // The during of creation or updating we send all images, existing and new uploaded
  // the in backend we do all process
  // we exclude deleted items and deleting data by missing ids in payload

  const {
    mainImageUrl,
    existingImages,
    uploadedFileList,
    ...restOfData
  } = data;

  // uploadedFileList exclude from payload
  const array = existingImages?.map((img) => img.id) || []

  let mainImageId = null

  if (mainImageUrl) {
    const [_, src] = mainImageUrl.split('images/')
    const path = `images/${src}`;

    mainImageId = existingImages?.find((image) => image.url === path)?.id || ''
  }

  return {
    ...restOfData,
    // eslint-disable-next-line no-unsafe-optional-chaining
    // new uploaded and existing images together
    images: [...imagePaths, ...array],
    mainImageId
  } as unknown as TeamCreationPayload;
};
